module.exports = __webpack_public_path__ + "static/img/li1_13.bc9ce31f.png";